import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-loader-small',
    templateUrl: './loader-small.component.html',
    styleUrls: ['./loader-small.component.scss'],
    standalone: true
})
export class LoaderSmallComponent {
  @Input() height = 'h-5';
  @Input() width = 'w-5';
}
